import React, { useState } from 'react';
import styled from 'styled-components'
import { Table } from 'antd';
import { Icon } from 'dlweb-components';
import _ from 'lodash';
import ContextMenu from '../../ContextMenu';

const MembersTable = ({loading, members, onRemoveUser, selectedUsers, setSelectedUsers, handleTableChange, pagination, sorter, groupName}) => {

  const [menuCoordinates, setMenuCoordinates] = useState({});

  const columns = [
    {
      key: 'ID',
      title: 'User ID',
      dataIndex: 'id',
      sorter: true,
      ellipsis: true,
      defaultSortOrder: 'ascend',
      sortOrder: sorter.columnKey === 'ID' ? sorter.order : null,
    },
    {
      key: 'FirstName',
      title: 'First Name',
      dataIndex: 'firstName',
      sorter: true,
      ellipsis: true,
      sortOrder: sorter.columnKey === 'FirstName' ? sorter.order : null,
    },
    {
      key: 'LastName',
      title: 'Last Name',
      dataIndex: 'lastName',
      sorter: true,
      ellipsis: true,
      sortOrder: sorter.columnKey === 'LastName' ? sorter.order : null,
    },
    {
      key: "Description",
      title: 'Description',
      dataIndex: 'description',
      ellipsis: true,
      sorter: true,
      sortOrder: sorter.columnKey === 'Description' ? sorter.order : null,
    },
    {
      key: "Department",
      title: 'Department',
      dataIndex: 'department',
      ellipsis: true,
      sorter: true,
      sortOrder: sorter.columnKey === 'Department' ? sorter.order : null,
    },
    {
      key: "Title",
      title: 'Title',
      dataIndex: 'title',
      ellipsis: true,
      sorter: true,
      sortOrder: sorter.columnKey === 'Title' ? sorter.order : null,
    },
    {
      key: "Supervisor",
      title: 'Manager',
      dataIndex: 'manager',
      ellipsis: true,
      sorter: true,
      sortOrder: sorter.columnKey === 'Supervisor' ? sorter.order : null,
    }
  ];

  const contextMenu = [{
    key: 'remove-user',
    action: 'remove-user',
    icon: <Icon type='user-minus' fixedWidth="25px" />,
    label: `Remove User${selectedUsers.length > 1 ? 's' : ''}`,
  }]

  const openContextMenu = (e, record) => {

    e.preventDefault();

    if(groupName === 'Admins' && record.id === 'cssadmin') return;

    const isSelected = e.target.closest('tr').className.indexOf('ant-table-row-selected') > -1;

    setSelectedUsers(true, !isSelected, [record]);
    
    let coordinates = { x: e.pageX - 400, y: e.pageY - 140 };

    setMenuCoordinates(coordinates);
  }

  const rowSelection = {
    selectedRowKeys: selectedUsers.map(o => o.id),
    onSelect: (selectedKey, selected) => {
      setSelectedUsers(selected, false, [selectedKey]);
    },
    onSelectMultiple: (selected, selectedRows) => {
      setSelectedUsers(selected, false, selectedRows);
    },
    onSelectAll: (selected, selectedRows) => {
      setSelectedUsers(selected, false, !selected ? members : selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: groupName === 'Admins' && record.id === 'cssadmin',
      name: record.name,
    }),
  };

  const onRowClick = (event, record) => {
    if (event.target.className.indexOf('ant-checkbox') > -1) return;
    if(groupName === 'Admins' && record.id === 'cssadmin') return;
    setSelectedUsers(true, true, [record]);
  }

  return(
    <TableContainer>
      <Table
        scroll={{y: 'calc(100vh - 625px)'}}
        rowKey="id"
        dataSource={members}
        showSorterTooltip={false}
        size="small"
        style={{marginTop: '10px'}}
        loading={loading}
        columns={columns}
        onChange={handleTableChange}
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        onRow={(record, rowIndex) => {
          return {
            onClick: event => onRowClick(event, record),
            onContextMenu: event => openContextMenu(event, record)
          };
        }}
        pagination={{
          total: pagination.total,
          current: pagination.current,
          showSizeChanger: false,
          defaultPageSize: 50,
          defaultCurrent: 1
        }}
      />
      <ContextMenu
        menuItems={contextMenu}
        coordinates={menuCoordinates}
        onClick={onRemoveUser}
        handleClose={() => setMenuCoordinates({})}
      />
    </TableContainer>
  )
}

const TableContainer = styled.div`
  width: 100%;
  display: inline-block;
  .ant-table-body,
  .ant-table-tbody,
  .ant-table-content,
  .ant-table-container,
  .ant-table-wrapper,
  .ant-table-placeholder,
  .ant-table-expanded-row-fixed {
    overflow: auto !important;
    min-height: calc(100vh - 625px);
  }
  .ant-table-cell:has(.ant-empty-normal) {
    border-bottom: none !important;
  }
`

export default MembersTable;